import { render, staticRenderFns } from "./BrowseGigsCard.htm?vue&type=template&id=6bae201e&scoped=true&"
import script from "./BrowseGigsCard.ts?vue&type=script&lang=js&"
export * from "./BrowseGigsCard.ts?vue&type=script&lang=js&"
import style0 from "./BrowseGigsCard.scss?vue&type=style&index=0&id=6bae201e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae201e",
  null
  
)

export default component.exports